import React from "react"
import styled from "styled-components"

import InputItemWrapper from "~/components/Form/InputItemWrapper"

const ValueText = styled.p`
  display: flex;
  align-items: center;
  max-width: 90vw; /* not ideal. quick fix to work on mobile. desktop is fine with 100% */
  min-height: 50px;
  margin: 0;
  border: 1px solid ${({ theme }) => theme.colors.background.main};
  border-bottom: 1px solid ${({ theme }) => theme.colors.ui.inputBorder};
  overflow: hidden;

  font-family: ${({ theme }) => theme.fonts.avenirNextMedium};
  text-indent: 15px;
  line-height: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
  
  color: ${({ theme }) => theme.colors.primary};
`

const DisplayInputContainer = ({ label, value, error, isEditing, children }) => (
  <InputItemWrapper label={label} error={error}>
    {isEditing ? children : <ValueText>{value}</ValueText>}
  </InputItemWrapper>
)

export default DisplayInputContainer
